/**
 * Production site URL (no trailing slash). Used for meta and links.
 * Set REACT_APP_SITE_URL on Vercel to match your primary domain, e.g. https://cure8studios.com
 */
export const SITE_ORIGIN = (process.env.REACT_APP_SITE_URL || 'https://cure8studios.com').replace(/\/$/, '');

/** Place `logo.png` in `public/` so it is served at the site root (do not use `./logo.png` — it breaks on nested routes). */
export const LOGO_URL = `${process.env.PUBLIC_URL || ''}/logo.png`;
